'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _constants = require('../../constants');

var _Core = require('../Core');

var _ArrowIcon = require('../Icon/ArrowIcon');

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var titleStyle = function titleStyle(_ref) {
  var collapsed = _ref.collapsed,
      showMore = _ref.showMore;
  return {
    display: 'block',
    fontSize: '18px',
    color: '#666',
    paddingLeft: '16px',
    margin: collapsed && !showMore ? '0 0 1rem' : '1rem 0'
  };
};

var Title = (0, _preactFela.createComponent)(titleStyle);

var notificationListStyle = function notificationListStyle(_ref2) {
  var mobile = _ref2.mobile,
      loading = _ref2.loading,
      collapsed = _ref2.collapsed,
      showMore = _ref2.showMore;
  return _extends({
    position: 'relative',
    width: !mobile ? '304px' : '100%',
    boxSizing: 'border-box',
    background: '#ffffff',
    overflowX: 'hidden',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch'
  }, collapsed && showMore && {
    position: 'absolute',
    top: '0',
    left: '0',
    height: '100%'
  }, loading && {
    '> *': {
      opacity: 0.5,
      pointerEvents: 'none'
    }
  }, {
    desktop: {
      maxHeight: '250px',
      /**  STYLE ScrollBar */
      '&::-webkit-scrollbar': {
        width: '7px',
        backgroundColor: '#f4f4f4'
      },
      '&::-webkit-scrollbar-track:active': {
        background: '#ffffff',
        border: '1px solid transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '10px',
        background: 'rgba(0,0,0,0.4)'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#888'
      },
      '&::-webkit-scrollbar-thumb:active': {
        background: '#999'
      }
    }
  });
};

var NotificationList = (0, _preactFela.createComponent)(notificationListStyle);

var notificationItemStyle = function notificationItemStyle(_ref3) {
  var isRead = _ref3.isRead;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    padding: '16px',
    cursor: 'pointer',
    background: isRead ? '#ffffff' : '#f4f4f4',
    borderTop: '2px solid ' + (!isRead ? '#ffffff' : '#f4f4f4'),
    boxSizing: 'border-box',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none'
    }
  };
};

var NotificationItem = (0, _preactFela.createComponentWithProxy)(notificationItemStyle, 'a');

var buttonBackStyle = function buttonBackStyle(_ref4) {
  var showMore = _ref4.showMore;
  return {
    display: showMore ? 'block' : 'none',
    fontSize: '12px',
    margin: '0.5rem 0 0'
  };
};

var ButtonBack = (0, _preactFela.createComponentWithProxy)(buttonBackStyle, _Core.Button);

var buttonShowMoreStyle = function buttonShowMoreStyle(_ref5) {
  var showMore = _ref5.showMore;
  return {
    display: showMore ? 'none' : 'block',
    fontSize: '12px',
    margin: '0.5rem auto'
  };
};

var ButtonShowMore = (0, _preactFela.createComponentWithProxy)(buttonShowMoreStyle, _Core.Button);

var rules = function rules() {
  return {
    itemBrand: {
      width: '16px',
      height: '16px'
    },
    itemContent: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      fontSize: '12px',
      color: '#949799',
      marginBottom: '8px'
    },
    itemTitle: {
      flex: '1 1 100%',
      marginRight: 'auto',
      padding: '0 8px'
    },
    itemDate: {
      whiteSpace: 'nowrap'
    },
    itemDescription: {
      fontSize: '14px',
      color: '#666'
    },
    noResult: {
      fontSize: '12px',
      color: '#949799',
      padding: '0 16px 16px'
    },
    iconBack: {
      transform: 'rotateY(180deg)'
    }
  };
};

var HeaderNotificationContent = function (_Component) {
  _inherits(HeaderNotificationContent, _Component);

  function HeaderNotificationContent(props) {
    _classCallCheck(this, HeaderNotificationContent);

    var _this = _possibleConstructorReturn(this, (HeaderNotificationContent.__proto__ || Object.getPrototypeOf(HeaderNotificationContent)).call(this, props));

    _this.setList = function (el) {
      if (el) {
        _this.list = el;
      }
    };

    _this.handleScroll = function () {
      if (!_this.props.notification.loading && _this.list.offsetHeight + _this.list.scrollTop + 10 >= _this.list.scrollHeight) {
        _this.state.offset = _this.props.notification.list.length;
        _this.props.notifications(_this.props.notification.list.length);
      }
    };

    _this.handleToggleShowMore = function () {
      _this.setState(function (state) {
        return { showMore: !state.showMore };
      }, function () {
        return _this.state.showMore && _this.handleScroll();
      });
    };

    _this.handleMarkRead = function (event, _ref6, index) {
      var url = _ref6.url,
          notificationId = _ref6.notificationId;

      event.preventDefault();
      _this.props.readNotifications(notificationId, url, index);
    };

    _this.setState({
      open: false,
      offset: _this.props.notification.list.length,
      showMore: false
    });
    return _this;
  }

  _createClass(HeaderNotificationContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.notification.list.length) {
        this.props.notifications(this.props.notification.list.length);
      }
      this.list.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          notification = _props.notification,
          styles = _props.styles,
          inScroll = _props.inScroll,
          mobile = _props.mobile,
          collapsed = _props.collapsed,
          config = _props.config;
      var showMore = this.state.showMore;

      var list = collapsed && !showMore ? notification.list.slice(0, 2) : notification.list;

      return (0, _preact.h)(
        NotificationList,
        {
          mobile: mobile,
          collapsed: collapsed,
          showMore: showMore,
          loading: notification.loading,
          innerRef: this.setList
        },
        collapsed && notification.list.length > 2 && (0, _preact.h)(
          ButtonBack,
          _extends({
            onClick: this.handleToggleShowMore,
            showMore: showMore,
            color: config.color
          }, (0, _utils.getAttrsGtm)('Voltar', { clicktype: 'menu' })),
          (0, _preact.h)(_ArrowIcon2.default, { color: config.color, className: styles.iconBack }),
          ' ',
          'Voltar'
        ),
        (0, _preact.h)(
          Title,
          { collapsed: collapsed, showMore: showMore },
          'Notifica\xE7\xF5es'
        ),
        (notification.loading && list.length === 0 || list.length === 0) && (0, _preact.h)(
          'p',
          { className: styles.noResult },
          notification.loading ? 'Carregando...' : 'Não há notificações no momento'
        ),
        (!notification.loading || list.length > 0) && list.map(function (notification, index) {
          return (0, _preact.h)(
            NotificationItem,
            _extends({
              href: notification.url,
              onClick: function onClick(event) {
                return _this2.handleMarkRead(event, notification, index);
              },
              isRead: notification.isRead,
              mobile: mobile
            }, (0, _utils.getAttrsGtm)(notification.description)),
            (0, _preact.h)(
              'span',
              { className: styles.itemContent },
              (0, _preact.h)('img', {
                src: _constants.PRODUCTS[notification.product].square,
                alt: _constants.PRODUCTS[notification.product].name,
                className: styles.itemBrand,
                inScroll: inScroll,
                mobile: mobile
              }),
              (0, _preact.h)(
                'span',
                { className: styles.itemTitle },
                notification.title || ''
              ),
              (0, _preact.h)(
                'span',
                { className: styles.itemDate },
                notification.date || ''
              )
            ),
            (0, _preact.h)(
              'span',
              { className: styles.itemDescription },
              notification.description
            )
          );
        }),
        collapsed && notification.list.length > 2 && (0, _preact.h)(
          ButtonShowMore,
          _extends({
            onClick: this.handleToggleShowMore,
            showMore: showMore,
            color: config.color
          }, (0, _utils.getAttrsGtm)('Ver mais', { clicktype: 'menu' })),
          'Ver mais'
        )
      );
    }
  }]);

  return HeaderNotificationContent;
}(_preact.Component);

exports.default = (0, _preactFela.connect)(rules)(HeaderNotificationContent);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/HeaderNotificationContent.js
// module id = 61
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38